import React, { Component } from "react";
import { getServices } from "../services/serviceService";

export class Service extends Component {
  constructor(props) {
    super(props);

    this.state = {
      services: [],
    };
  }

  async componentDidMount() {
    try {
      const data = await getServices();

      this.setState({
        services: data,
      });

      console.log("SERVICES:", data);
    } catch (error) {
      console.log(error);
    }
  }

  render() {
    const { services } = this.state;

    return (
      <div>
        {/* Service Start */}
        <div className="container-fluid py-5">
          <div className="container">

            <div
              className="text-center wow fadeIn"
              data-wow-delay="0.1s"
            >
              <h1 className="mb-5">
                <span className="text-uppercase bg-primary text-white rounded px-2">
                  Services
                </span>{" "}
                What Solutions We Provide
              </h1>
            </div>

            <div className="row g-4 justify-content-center">

              {services.map((service, index) => (

                <div
                  key={service.service_id}
                  className="col-lg-3 col-md-6 wow fadeIn"
                  data-wow-delay={`${(index + 1) * 0.1}s`}
                >

                  <div className="service-item h-100 p-5 pt-0">

                    <div className="d-flex align-items-center ms-n5 mb-4">

                      <div className="service-icon flex-shrink-0 bg-primary me-4">

                        <i
                          className={`${service.service_icon} fa-3x text-white`}
                        ></i>

                      </div>

                      <h4 className="mb-0">
                        {service.service_name}
                      </h4>

                    </div>

                    <p className="mb-4">
                      {service.service_description}
                    </p>

                    <a
                      className="btn btn-secondary px-3"
                      href={`/service/${service.service_slug}`}
                    >
                      Learn More
                    </a>

                  </div>

                </div>

              ))}

            </div>

          </div>
        </div>
        {/* Service End */}
      </div>
    );
  }
}

export default Service;